import { NavLink } from 'react-router-dom'; 
import styles from './Header.module.css';
import logo from '../src/assets/logo.png'

const Header = () => {

    return (
        <div className={styles.headerWrapper}>
            <div className={styles.logoSection}>
                <img
                    src={logo}
                    alt="Deep Algorithms Logo"
                    style={{ height: 50, marginRight: 10 }}
                />
            </div>

            <div className={styles.menuBar}>
                <NavLink
                    to="/"
                    className={({ isActive }) =>
                        isActive ? `${styles.menuTab} ${styles.menuTabActive}` : styles.menuTab
                    }
                >
                    CASES
                </NavLink>
                {/* <NavLink
                    to="/"
                    className={({ isActive }) =>
                        isActive ? `${styles.menuTab} ${styles.menuTabActive}` : styles.menuTab
                    }
                    end 
                >
                    ACTION
                </NavLink> */}
                <NavLink
                    to="/report"
                    className={({ isActive }) =>
                        isActive ? `${styles.menuTab} ${styles.menuTabActive}` : styles.menuTab
                    }
                >
                    REPORT
                </NavLink>
            </div>
        </div>
    );
};

export default Header;